import React from 'react';
import { colors, fonts, sectionLabelStyle, gradients } from './styles';
import { Highlight } from './Highlight';

export const WhatIsPulseCheckSection = () => {
  return (
    <section
      style={{
        backgroundColor: colors.lightGray,
        padding: '96px 48px',
        boxSizing: 'border-box',
      }}
    >
      <style>{`
        @media (max-width: 768px) {
          .pi-solution-wrap { padding-left: 24px !important; padding-right: 24px !important; padding-top: 64px !important; padding-bottom: 64px !important; }
          .pi-pulse-callout { padding: 28px !important; }
        }
      `}</style>
      <div className="pi-solution-wrap" style={{ maxWidth: '760px', margin: '0 auto', textAlign: 'center' }}>
        <p style={{ ...sectionLabelStyle, textAlign: 'center' }}>The solution</p>
        <h2
          style={{
            fontFamily: fonts.serif,
            fontSize: 'clamp(26px, 3vw, 40px)',
            fontWeight: 700,
            lineHeight: 1.2,
            color: colors.charcoal,
            margin: '0 0 24px',
          }}
        >
          On-demand patient intelligence,
          <br />
          delivered through Pulse Checks<sup style={{ fontSize: '0.5em', verticalAlign: 'super' }}>TM</sup>.
        </h2>
        <p
          style={{
            fontFamily: fonts.sans,
            fontSize: '17px',
            lineHeight: 1.75,
            color: colors.warmGray,
            maxWidth: '640px',
            margin: '0 auto 16px',
            fontWeight: 400,
          }}
        >
          Real Patients<sup style={{ fontSize: '0.6em', verticalAlign: 'super' }}>TM</sup> has spent a decade earning the trust of patient communities — building relationships deep enough that patients engage, respond, and come back. That community trust is the foundation that makes on-demand intelligence possible.
        </p>
        <p
          style={{
            fontFamily: fonts.sans,
            fontSize: '17px',
            lineHeight: 1.75,
            color: colors.warmGray,
            maxWidth: '640px',
            margin: '0 auto 16px',
            fontWeight: 400,
          }}
        >
          <Highlight>Our community is always growing</Highlight>. And as it does, each Pulse Check adds to a continuously deepening intelligence base — making your answers{' '}
          <strong style={{ color: colors.charcoal, fontWeight: 600 }}>smarter, faster, and more grounded</strong>{' '}
          over time in ways that one-off research never can.
        </p>

        <div
          className="pi-pulse-callout"
          style={{
            background: `${gradients.primarySoft}, ${colors.white}`,
            borderRadius: '14px',
            padding: '32px 36px',
            maxWidth: '620px',
            margin: '56px auto 0',
            textAlign: 'center',
            boxShadow: '0 8px 32px rgba(0,0,0,0.06)',
            border: '1px solid rgba(235,160,155,0.22)',
          }}
        >
          <div
            style={{
              fontFamily: fonts.sans,
              fontSize: '10px',
              fontWeight: 700,
              letterSpacing: '2px',
              textTransform: 'uppercase',
              color: colors.deepCoral,
              marginBottom: '14px',
            }}
          >
            What is a Pulse Check<sup style={{ fontSize: '0.7em', verticalAlign: 'super' }}>TM</sup>?
          </div>
          <div
            style={{
              fontFamily: fonts.serif,
              fontSize: '24px',
              fontWeight: 700,
              color: colors.charcoal,
              marginBottom: '14px',
              lineHeight: 1.3,
            }}
          >
            A focused, rapid patient inquiry — returned in days.
          </div>
          <div
            style={{
              fontFamily: fonts.sans,
              fontSize: '15px',
              color: colors.warmGray,
              lineHeight: 1.65,
              fontWeight: 400,
            }}
          >
            Your team brings the question. We shape it with verified patients and return structured intelligence in days — no scoping, no long timelines.
          </div>
        </div>
      </div>
    </section>
  );
};
